import { produce } from 'immer';

import * as Types from './types';
import * as helpers from './helpers';
import { actionTypes } from './constants';

export const defaultState: Types.ITermsConditionsState = {
    termsConditions: {}
};

export const reducer = produce((draftState, action: Types.TTermsConditionsAction): Types.ITermsConditionsState | void => {
    switch (action.type) {
        case actionTypes.UPDATE_TERMS_CONDITIONS: {
            const { lang, data } = action.payload;

            if ('error' in data) {
                draftState.termsConditions[lang] = { error: data.error };
            } else {
                draftState.termsConditions[lang] = helpers.getContent(data);
            }

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
